<template>
  <div v-if="timer" id="timer">
    {{ timer }}
  </div>
</template>

<script>
export default {
  props: {
    timer: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
@keyframes timer {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    transform: translate(-50%, -50%) scale(0);
  }
}
#timer {
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 75vh;
  font-weight: bold;
  animation: timer 1s;
  font-variation-settings: "SOFT" 100, "wght" 900, "WONK" 1, "opsz" 144;
  text-shadow: 15px 15px #fff;
}
</style>